import { render, staticRenderFns } from "./OctItemList.vue?vue&type=template&id=47aae5ed&scoped=true&"
import script from "./OctItemList.vue?vue&type=script&lang=js&"
export * from "./OctItemList.vue?vue&type=script&lang=js&"
import style0 from "./OctItemList.vue?vue&type=style&index=0&id=47aae5ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aae5ed",
  null
  
)

export default component.exports